<template>
    <v-dialog v-model="objFormModal.abrirModal" :width="objFormModal.size" :scrollable="$root.isTouch == false"
        :fullscreen="$root.isTouch" persistent>
        <v-card elevation="11">
            <v-card-title class="bg-title-card">
                <span class="white--text headline" v-html="objFormModal.titulo"></span>
                <v-spacer></v-spacer>
                <v-btn v-if="$root.isTouch" icon dark @click="onCargaGeneral">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-form ref="form_modal_accesorio" :lazy-validation="true">
                    <v-container fluid grid-list-sm>
                        <v-row dense>
                            <v-col cols="12" sm="12">
                                <v-text-field label="Anchura del Neumático *" color="textbox"
                                    v-model.trim="objFormModal.anchura" :rules="requeridoRegla" outlined dense
                                    :disabled="_.get(objFormModal,'disabled',false)" />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12">
                                <v-text-field label="Rin *" color="textbox" v-model.trim="objFormModal.rin" outlined
                                    dense :rules="requeridoRegla" :disabled="_.get(objFormModal,'disabled',false)" />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12">
                                <v-text-field label="Perfil *" color="textbox" v-model.trim="objFormModal.perfil"
                                    :rules="requeridoRegla" outlined dense
                                    :disabled="_.get(objFormModal,'disabled',false)" />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12">
                                <v-text-field label="Cantidad *" color="textbox" v-model.number="objFormModal.cantidad"
                                    :rules="_.concat(requeridoRegla,numeroRegla)" outlined dense
                                    :disabled="_.get(objFormModal,'disabled',false)" />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12">
                                <v-text-field label="Valor Asegurado *" color="textbox"
                                    v-model.number="objFormModal.valorAsegurado"
                                    :rules="_.concat(requeridoRegla,decimal,reglaValorMax)" outlined dense
                                    :disabled="_.get(objFormModal,'disabled',false)" />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12">
                                <v-row dense>
                                    <v-col xs12 sm6>
                                        <v-text-field label="Foto de Factura *" color="textbox"
                                            prepend-inner-icon="add_photo_alternate"
                                            v-model.trim="objFormModal.name_factura" @click="openExplorer('factura')"
                                            :rules="(requeridoRegla)" readonly outlined dense
                                            :disabled="_.get(objFormModal,'disabled',false)" />

                                        <input type="file" style="display: none" ref="factura"
                                            accept="image/jpg,image/jpeg,image/png"
                                            @change="onFilePicked($event,'factura')" />
                                    </v-col>
                                    <v-col xs12 sm6>
                                        <v-text-field label="Foto de Accesorio *" color="textbox"
                                            prepend-inner-icon="add_photo_alternate"
                                            v-model.trim="objFormModal.name_foto" @click="openExplorer('foto')"
                                            :rules="(requeridoRegla)" readonly outlined dense
                                            :disabled="_.get(objFormModal,'disabled',false)" />

                                        <input type="file" style="display: none" ref="foto"
                                            accept="image/jpg,image/jpeg,image/png"
                                            @change="onFilePicked($event,'foto')" />
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12" class="text-center">
                                <v-btn outlined dense rounded color="danger" @click="onCargaGeneral">Salir</v-btn>

                                <v-btn outlined dense rounded color="danger" @click="addAccesorio($event,true)"
                                    class="ml-1" :disabled="_.isUndefined(objFormModal.index)">Eliminar</v-btn>

                                <v-btn rounded dark color="primary" @click="addAccesorio" class="ml-1"
                                    :disabled="_.get(objFormModal,'disabledBtn',false)">Guardar</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: ['objModal', 'porc_casco_permitir_valor_accesorio_adicional', 'valorCasco'],
        inject: ['addListAccesorio'],
        name: 'ModalAccesorioLlantaComponent',
        data() {
            return {
                objFormModal: {
                    titulo: 'Información de Accesorio',
                    abrirModal: false
                },
                valorMaxAccesorio: 0
            }
        },
        watch: {
            objModal: {
                handler(val) {
                    if (val.abrirModal) {
                        this.objFormModal = _.clone(this.objModal);
                        this.valorMaxAccesorio = (parseFloat(this.valorCasco) * parseFloat(this.porc_casco_permitir_valor_accesorio_adicional)) / 100;
                        if (!_.isUndefined(this.$refs.form_modal_accesorio))
                            this.$refs.form_modal_accesorio.resetValidation();
                    }
                },
                deep: true
            }
        },
        computed: {
            reglaValorMax() {
                var valor = _.clone(this.valorMaxAccesorio);
                if (parseInt(this.objFormModal.genera_solicitud) == 0)
                    return [v => v <= valor || `Debe ingresar un valor máximo hasta $ ${valor}`]
                else
                    return [];
            }
        },
        methods: {
            onCargaGeneral() {
                this.objFormModal = {
                    titulo: 'Información de Accesorio',
                    abrirModal: false
                };
                this.$refs.form_modal_accesorio.resetValidation();
                this.$parent.resetModal();
            },
            addAccesorio(e, remove = false) {
                try {
                    if (!this.$refs.form_modal_accesorio.validate()) throw mensajeEstandar.corregirInformacion;
                    this.addListAccesorio(this.objFormModal, remove)
                        .then((r) => {
                            if (!r) throw 'Error al guardar el accesorio.';
                            this.onCargaGeneral();
                        })
                        .catch((e) => {
                            mensajesAlerta(e, 'E');
                        });
                } catch (error) {
                    mensajesAlerta(error, 'E');
                }
            },
            openExplorer(e) {
                this.$refs[e].click();
            },
            onFilePicked(e, evento) {
                try {
                    var files = e.target.files
                    if (_.isUndefined(files[0])) throw mensajeEstandar.archivo;
                    if (files[0].name.lastIndexOf('.') <= 0) throw mensajeEstandar.archivo;
                    if ((files[0].name.search('.png') == -1) && (files[0].name.search('.jpg') == -1) && (files[0].name
                            .search('.jpeg') == -1)) throw mensajeEstandar.archivo;

                    var fr = new FileReader()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.$set(this.objFormModal, evento, fr.result);
                        this.$set(this.objFormModal, 'name_' + evento, files[0].name);
                        this.$forceUpdate();
                    })

                } catch (error) {
                    this.$set(this.objFormModal, evento, null);
                    this.$set(this.objFormModal, 'name_' + evento, null);
                    mensajesAlerta(error, 'I');
                }
            }
        }
    }
</script>